// Real placeholder photos (Wikimedia Commons, freely licensed) used wherever
// we don't have an actual listing photo yet (no photographer upload
// delivered). Each one is a genuine, verified real-estate-quality photo of
// some other property — clearly not this listing's own photos, but at least
// real photography rather than a random/irrelevant/watermarked stock result
// or an illustrated placeholder. Swap for real uploads via PhotographyStage.
const PHOTOS = {
  exterior: "https://commons.wikimedia.org/wiki/Special:FilePath/955%20Mellody%20Rd.JPG?width=500",
  living: "https://commons.wikimedia.org/wiki/Special:FilePath/Apartment-in-Berlin-by-Dezest-design-01.jpg?width=500",
  kitchen: "https://commons.wikimedia.org/wiki/Special:FilePath/8527-Brier-Dr-1.jpg?width=500",
  bedroom: "https://commons.wikimedia.org/wiki/Special:FilePath/Bedroom%20large%20double%20bed.jpg?width=500",
};

export default function PlaceholderPhoto({ label = "exterior", height = 140 }) {
  const src = PHOTOS[label] || PHOTOS.exterior;
  return (
    <div style={{ height, borderRadius: 12, overflow: "hidden", border: "1px solid #d8ede6", position: "relative" }}>
      <img src={src} alt={label} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      <span
        style={{
          position: "absolute", bottom: 6, left: 8, fontFamily: "'DM Mono',monospace", fontSize: 9,
          letterSpacing: "0.06em", textTransform: "uppercase", color: "#152d21", background: "rgba(255,255,255,0.85)",
          padding: "2px 6px", borderRadius: 6,
        }}
      >{label} · sample</span>
    </div>
  );
}
